import request from '@/utils/ajax';




// 添加维度
export function addDimension(data) {
  return request({
    url: `/wx//sys/dataPermissionDimension/save`,
    method: 'POST',
    data: data
  });
}


